import { Skeleton } from '@/shared/components/ui/skeleton';

export function WorkstationsPendingState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-auto p-4" aria-busy="true">
      <header className="space-y-2">
        <Skeleton className="h-5 w-28" />
        <Skeleton className="h-4 w-96 max-w-full" />
      </header>
      <div className="grid min-h-0 flex-1 gap-3 xl:grid-cols-[minmax(0,1fr)_26rem]">
        <Skeleton className="min-h-72 rounded-lg" />
        <Skeleton className="min-h-72 rounded-lg" />
      </div>
    </div>
  );
}
